<template>
  <v-layout row wrap>
    <form-dialog
      v-if="can('add_assessments')"
      v-model="dialog"
      :title="formTitle"
      @input="reset"
    >
      <v-sheet class="py-2 px-4">
        <date :label="$t('assessment_date')" v-model="assessment.date" />
        <div class="my-2 di-flex justify-end">
          <v-btn color="btn_color secondary" :loading="loading" @click="save">{{
            $t("save")
          }}</v-btn>
        </div>
      </v-sheet>
    </form-dialog>

    <form-dialog
      fullscreen
      :title="formTitle"
      @input="$emit('reload')"
      v-if="can('edit_assessments')"
      v-model="reAssessmentDialog"
    >
      <v-sheet>
        <reAssessment ref="reAssessmentForm" :assessment="assessment" />
      </v-sheet>
    </form-dialog>

    <v-flex xs12 class="di-flex justify-space-between align-center my-3">
      <strong class="title_label">
        <span>{{ $t(`assessments`) }}</span>
      </strong>
    </v-flex>

    <v-expansion-panel class="flex xs12 shadow">
      <v-expansion-panel-content v-for="item in items" :key="item.id">
        <template v-slot:header>
          <strong>{{ `${item.type} (${item.date})` }}</strong>
        </template>
        <v-card flat class="pa-2">
          <score-card-summary :summary="item.summary" />
          <v-card-actions class>
            <v-tooltip
              top
              v-if="item.type == 'Re-Assessment' && can('delete_assessments')"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  flat
                  small
                  v-on="on"
                  class="ma-0 pa-0"
                  color="grey darken-2"
                  @click="deleteItem(item)"
                >
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>

            <v-tooltip top v-if="can('edit_assessments')">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  flat
                  small
                  v-on="on"
                  class="ma-0 pa-0"
                  color="grey darken-2"
                  @click="editItem(item)"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>

            <v-spacer />

            <v-btn
              dark
              flat
              color="teal"
              :loading="loading"
              @click="downloadReport(cso, 'assessment_report')"
              v-if="
                cso.assessment_report &&
                  item.type == 'Primary-Assessment' &&
                  can('view_assessments')
              "
            >
              <v-icon class="mr-1">mdi-arrow-down-bold-box-outline</v-icon>
              <span class="mt-1 font-weight-medium">Download Report</span>
            </v-btn>
            <v-btn
              dark
              flat
              color="teal"
              :loading="loading"
              @click="downloadReport(cso, 're_assessment_report')"
              v-if="
                cso.re_assessment_report &&
                  item.type == 'Re-Assessment' &&
                  can('view_assessments')
              "
            >
              <v-icon class="mr-1">mdi-arrow-down-bold-box-outline</v-icon>
              <span class="mt-1 font-weight-medium">Download Report</span>
            </v-btn>
            <v-btn
              small
              outline
              @click="reAssessment(item)"
              v-if="
                item.type == 'Primary-Assessment' &&
                  can('add_assessments') &&
                  cso.latest_assessment.decision == 'Deferred'
              "
            >
              <v-icon class="mr-1" color="primary">mdi-restart</v-icon>
              <span>RE - Assissment</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-layout>
</template>

<script>
export default {
  name: "CSOassessments",
  props: ["type", "items", "cso"],
  components: {
    reAssessment: () => import("./forms/reAssessment")
  },

  data() {
    return {
      dialog: false,
      loading: false,
      assessment: {},
      editedIndex: -1,
      reAssessmentDialog: false
    };
  },

  computed: {
    headers: vm => [
      { text: vm.$t("standards"), value: "standard", sortable: false },
      {
        sortable: false,
        value: "no_of_standard",
        text: vm.$t("no_of_standard")
      },
      {
        sortable: false,
        value: "total_score",
        text: vm.$t("total_score")
      },
      {
        sortable: false,
        value: "qualifying_score",
        text: vm.$t("qualifying_score")
      },
      {
        sortable: false,
        value: "score_obtained",
        text: vm.$t("score_obtained")
      },
      {
        value: "status",
        sortable: false,
        text: vm.$t("status")
      }
    ],

    formTitle: vm => (vm.editedIndex > -1 ? `Edit Assessment` : `Re Assessment`)
  },

  methods: {
    deleteItem(item) {
      let vm = this;
      this.$alert(`/assessments/${item.id}`).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1);
      });
    },

    reAssessment(item) {
      this.assessment.cso_id = item.cso_id;
      this.assessment.summary = item.summary;
      this.assessment.assessment_id = item.id;
      this.assessment.decision = item.decision;
      this.assessment.recommendation = item.recommendation;
      this.dialog = true;
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.assessment = Object.assign({}, item);
      this.$refs.reAssessmentForm.initData();
      this.reAssessmentDialog = true;
    },

    reset() {
      this.assessment = {
        id: null,
        decision: null,
        assessment_id: null,
        recommendation: null,
        type: "Re-Assessment",
        summary: { items: [] },
        cso_id: this.$route.params.id,
        date: new Date().toISOString().substring(0, 10)
      };
      this.dialog = false;
      this.loading = false;
      this.editedIndex = -1;
      this.$validator.reset();
    },

    save() {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) {
          this.axios
            .post("assessments", this.assessment)
            .then(res => {
              if (this.editedIndex > -1)
                Object.assign(this.items[this.editedIndex], res.data.data);
              else this.items.push(res.data.data);
              this.reset();
            })
            .catch(() => (this.loading = false));
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
        }
      });
    }
  },

  created() {
    this.reset();
  }
};
</script>
